import { Component, inject } from '@angular/core';
import { AgendaComponent } from '../../components/agenda/agenda.component';
import { MarkdownModule } from "ngx-markdown";
import { AccrocheComponent } from '../../components/accroche/accroche.component';
import { PresentationPrestationsComponent } from "../../components/presentation-prestations/presentation-prestations.component";
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-home',
  imports: [AgendaComponent, MarkdownModule, AccrocheComponent, PresentationPrestationsComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  apiService:ApiService = inject(ApiService);
  ngOnInit():void {
    this.apiService.getTypesAteliers().subscribe((data) => {
      console.log('Types d\'ateliers:', data);
    })
  }
}
